module.exports = __webpack_public_path__ + "static/media/[Keats_and_Beats]2013-03-21.6818d320.md";